import { Badge } from '@/components/ui/Badge'

type BonusAssessmentStatus = 'rascunho' | 'em_apuracao' | 'validacao_rh' | 'finalizado'

interface StatusBadgeProps {
  status: BonusAssessmentStatus
}

const variantMap: Record<BonusAssessmentStatus, 'default' | 'warning' | 'info' | 'success'> = {
  rascunho: 'default',
  em_apuracao: 'warning',
  validacao_rh: 'info',
  finalizado: 'success',
}

const labelMap: Record<BonusAssessmentStatus, string> = {
  rascunho: 'Rascunho',
  em_apuracao: 'Em Apuração',
  validacao_rh: 'Validação RH',
  finalizado: 'Finalizado',
}

const dotColorMap: Record<BonusAssessmentStatus, string> = {
  rascunho: 'bg-brand-gray',
  em_apuracao: 'bg-warning',
  validacao_rh: 'bg-info',
  finalizado: 'bg-success',
}

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <Badge
      variant={variantMap[status]}
      data-testid={`status-badge-${status}`}
      className="inline-flex items-center gap-1.5"
    >
      <span className={`inline-block w-1.5 h-1.5 rounded-full ${dotColorMap[status]}`} />
      {labelMap[status]}
    </Badge>
  )
}
